import { StarInactiveIcon, StartActiveIcon } from "assets/icons";
import cn from "classnames";
import { Icon } from "ui/Icon";

import { RatingStarsProps } from "./RatingStars.types";

import styles from "./RatingStars.module.scss";

const RatingStars = ({ grade, size, className }: RatingStarsProps) => {
  return (
    <div className={cn(styles.stars, className)}>
      {Array.from({ length: 5 }, (_, i) => i + 1).map((starNumber) => (
        <Icon
          key={starNumber}
          boxSize={size}
          as={starNumber <= grade ? StartActiveIcon : StarInactiveIcon}
        />
      ))}
    </div>
  );
};

export default RatingStars;
